/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Selection_Has_LinkInputs */



/**
* | output |
* | --- |
* | "Selection already contains a link" |
*
* @param {Editor_Selection_Has_LinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_selection_has_link = /** @type {((inputs?: Editor_Selection_Has_LinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Selection_Has_LinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Auswahl enthält bereits einen Link")
	return /** @type {LocalizedString} */ ("Selection already contains a link")
});